var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSoftDrinks = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Soft-Drinks-Glass--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Soft Drinks Glass Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.17 1a1 1 0 1 0 2 0 1 1 0 1 0 -2 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.17 3.25a1 1 0 1 0 2 0 1 1 0 1 0 -2 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.28 5.5a1.46 1.46 0 0 0 -1.11 -0.5h-7.49a0.49 0.49 0 0 1 -0.5 -0.45l-0.1 -1A3.88 3.88 0 0 0 7.21 0H4.33a1 1 0 0 0 0 2h2.88a1.89 1.89 0 0 1 1.88 1.71l0.07 0.74a0.52 0.52 0 0 1 -0.16 0.39 0.51 0.51 0 0 1 -0.34 0.16H7.17a1.45 1.45 0 0 0 -1.11 0.5 1.54 1.54 0 0 0 -0.39 1.18c0.59 4.89 0.08 0.58 1.89 16A1.5 1.5 0 0 0 9.05 24h8.24a1.5 1.5 0 0 0 1.48 -1.32c1.8 -15.3 1.3 -11 1.89 -16a1.51 1.51 0 0 0 -0.38 -1.18ZM9.43 8.84a0.51 0.51 0 0 1 -0.37 0.16h-0.65a0.51 0.51 0 0 1 -0.5 -0.44l-0.12 -1a0.52 0.52 0 0 1 0.13 -0.39 0.48 0.48 0 0 1 0.37 -0.17H9a0.5 0.5 0 0 1 0.5 0.45l0.1 1a0.56 0.56 0 0 1 -0.17 0.39Zm2.24 6.41a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Zm2 5a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Zm2.5 -7a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Zm2.25 -4.69a0.5 0.5 0 0 1 -0.49 0.44h-5.86a0.49 0.49 0 0 1 -0.49 -0.45l-0.1 -1a0.51 0.51 0 0 1 0.12 -0.39A0.52 0.52 0 0 1 12 7h6a0.5 0.5 0 0 1 0.5 0.56Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSoftDrinks);
export default ForwardRef;